export default "__VITE_ASSET__e050729c__"